import styled from 'styled-components';
import { ButtonV2 } from "@getgrover/ui";

import Modal from 'ggApp/modules/modal/components/v3/modal';

const MODAL_CONTAINER_CLASS_NAME = 'PreventSefCheckoutContainer';
const MODAL_CONTENT_CLASS_NAME = 'PreventSefCheckoutContent';

export const StyledModal = styled(Modal).attrs({
    classNames: {
        container: MODAL_CONTAINER_CLASS_NAME,
        content: MODAL_CONTENT_CLASS_NAME,
    },
})`
    display: flex;
    flex-direction: column;

    & .${MODAL_CONTAINER_CLASS_NAME} {
        width: 384px;
        min-height: 30vh;
        height: 60vh;
        max-height: 100%;

        ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMax.css`
            height: fit-content;
            min-height: 600px;
            max-height: 60vh;
        `};
    }

    & .${MODAL_CONTENT_CLASS_NAME} {
        padding: 0 0 ${props => props.theme.spacers.XXL};
        user-select: none;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            padding-bottom: ${theme.spacers.L};
        `};
    }

    & .${MODAL_CONTENT_CLASS_NAME} > div:last-of-type {
        display: none;
    }
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    z-index: 1;
    right: ${({ theme }) => theme.spacers.L};
    top: ${({ theme }) => theme.spacers.XL};
    cursor: pointer;
`;

export const CloseButton = styled(ButtonV2)`
    padding: 0;
`;

export const Top = styled.section`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacers.XXL};
`;

export const Bottom = styled.section`
  display: flex;
  flex-direction: column;
  max-height: 300px;
  padding: 0 ${props => props.theme.spacers.XXL};
  ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
    padding: 0 ${theme.spacers.L};
  `};
`;

export const Header = styled.h4`
  ${({ theme }) => theme.typography.Subheadline};
  margin-top: ${({ theme }) => theme.spacers.XXL};
`;

export const Description = styled.p`
  margin-top: ${({ theme }) => theme.spacers.L};
  color: ${({ theme }) => theme.colors['Level 5']};
  ${({ theme }) => theme.typography.Paragraph};
`;

export const HelpCenterButton = styled(ButtonV2).attrs({
    fullWidth: true,
})`
  margin-top: ${props => props.theme.spacers.L};
`;
